const redirectUri = import.meta.env.VITE_REDIRECT_URI || `${window.location.origin}/`;

export const msalConfig = {
    auth: {
        clientId: import.meta.env.VITE_CLIENT_ID,
        authority: import.meta.env.VITE_AUTHORITY,
        redirectUri,
        postLogoutRedirectUri: redirectUri,
        // Stay on redirectUri after login; avoid restoring a broken pre-login hash route.
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    default:
                        return;
                }
            }
        },
    }
};
